module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAAXNSR0IArs4c6QAAAPJJREFUKFNlkLFKw2AUhb/7533cnFwKJlGkBYv4p4iIiEPHvoH1FboVBcVB00RFJIMmUUGcXH2e/FfS0jbWM95zuOfjCJP8ByNn7AePrCp566LVOVG4JqR5iCMF+kTh3SIbv/YQGSMuwm6/yNRIixZOnxAG2PCatDhCGeFJlz3/o47MgrUm+QZChpIhtEE62OBrbgtJ8QluiN16Jy7XwY0xXh+7+T1tUobYoCUkZYRWF4jammXRsMI+q74vd3F6A3qIDZ9JyzauusWY4/kaTcYd0BjMJbhT1Dug52dLxuZ2D6VP5a7AnGD9omktP/5b++/hF/8OWQtQXhaTAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/down.png
// module id = zO/J
// module chunks = 0